// extracted by mini-css-extract-plugin
export default {"taro_wrapper":"ResourceList_taro_wrapper__Y0CNU","noTopPadding":"ResourceList_noTopPadding__SsxDk","noBtmPadding":"ResourceList_noBtmPadding__SAen5"};